import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {BDCRoutingModule} from './bdc-routing.module';
import {BdcSharedModule} from './shared/bdc-shared.module';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    SharedModule,
    BdcSharedModule,
    BDCRoutingModule
  ]
})
export class BdcModule { }
